import Vue from 'vue'
import Vuex from 'vuex'
import Cookies from 'js-cookie';

Vue.use(Vuex)

import cloneDeep from 'lodash/cloneDeep'

import { getTrackData, getTracks, checkAuthentication } from '../firebase'
import { transform_k_track_v_data_noTN_zbool, transform_k_track_v_data_noTN_zbool2 } from '../helpers'

import categoryTracks from '../refs/categoryTracks'
import categoryTracksPCC from '../refs/categoryTracksPCC'
import trackDetails from '../refs/trackDetails'
import trackDetailsPCC from '../refs/trackDetailsPCC'
import sampleHisto from '../refs/sampleHisto'
import sampleMeta from '../refs/sampleMeta'
import sampleMetaPCC from '../refs/sampleMetaPCC'
import available from '../refs/available'
import availablePCC from '../refs/availablePCC'
import geneTracks from '../refs/geneTracks'
import geneTracksPCC from '../refs/geneTracksPCC'
import sortFn from '../sortFn'
import stratifyVar from '../refs/stratifyVar';
import PfsCurveplot from '../components/PFSCurveplot/PfsCurveplot.vue';

export default new Vuex.Store({
  state: {
    available,
    availableGenes: {'PTRC': available, 'PCC': availablePCC },
    geneTracksList: {'PTRC': geneTracks, 'PCC': geneTracksPCC },
    categoryTracksList: {'PTRC': categoryTracks, 'PCC': categoryTracksPCC },
    trackDetailsList: {'PTRC': trackDetails, 'PCC': trackDetailsPCC},
    sampleMetaList: {'PTRC': sampleMeta, 'PCC': sampleMetaPCC},
    Boxplot_data: {},
    Boxplot_data_raw: {},
    Boxplot_dataType: 'All',
    Boxplot_genes: [],
    Boxplot_stratifyByPrimary: null,
    Boxplot_stratifyBy: null,
    Boxplot_stratify: false,
    Boxplot_useZScore: false,
    Boxplot_combinedCohort: false,
    Boxplot_tab: 'tab-1',
    Boxplot_cohortSelected: ['discovery', 'validation'],
    // TODO: switch between study
    Boxplot_categoryTracks: {'PTRC': [
                              'response',
                              'sex',
                              // 'cohort',
                              'age_group',
                              'stage_coding',
                              'Biopsy_site_tissue',
                              // 'FFPE Sample Type',
                              'ICI_cluster',
                            ...cloneDeep(categoryTracks.Mutation)], 
                            'PCC': [
                              'sex',
                              'age_group',
                              'tumor_stage',
                              'Radiation-therapy',
                              'Chemo-therapy',
                              'Immuno-therapy',
                              'Targeted-therapy',
                              'BRAF_hotspot',
                              'NRAS_hotspot',
                              // 'KRAS_hotspot',
                              'SNF_group_of_interest',
                              'transcriptional_state_classification',
                              'ubi_cluster',
                              'ICI_cluster',
                              'glyco cluster',
                              ...cloneDeep(categoryTracksPCC.Mutation)
                              // 'FFPE Sample Type'
                            ]}, 
    
    // HistologyViewer_mutationGene: '',
    // HistologyViewer_Sample: 'C3N-00831',
    routerPage: '',
    router_to_headerInfo: {
                          // 'PTRC': ['PTRC', 
                          //           'PTRC citation placeholder'],
                          //  'PCC': ['PCC', 
                          //           'PCC citation placeholder'],
                          // 'ICI subtype study (Chowhury et. al.)': ['PTRC', 
                          //           'PTRC citation placeholder'],
                          //  'Deep profiling study (Gong et. al.)': ['PCC', 
                          //           'PCC citation placeholder'],
                          '/ptrc': ['PTRC', 
                                    'Chowdhury et. al. "Identification of Proteomic Subtypes with Differential Responses to Immune Checkpoint Inhibition in Melanoma"'],
                           '/pcc': ['PCC', 
                                    'Gong et. al., "A comprehensive proteogenomic, immunopeptidomic, and metabolomic atlas decodes immunogenicity in cutaneous melanoma"'],
                          
                                  },
    // Header_cohortName: 'PTRC',
    // Header_studyReference: 'Citation PTRC placeholder',
    Heatmap_categoryTracks: {'PTRC':cloneDeep(categoryTracks),
                             'PCC':cloneDeep(categoryTracksPCC)},
    Heatmap_categoryTracksFiltered: {'PTRC':cloneDeep(categoryTracks),
                                    'PCC':cloneDeep(categoryTracksPCC)},
    Heatmap_data: {},
    Heatmap_dataTypes: ['CNV', 'RNA', 'Proteo', 'CellType', 
            'Kinase', 'TranscriptionFactor', 'ubiq', 'glyco', 'phospho', 'Mutation'],
    Heatmap_shownDataTypes: ['CNV', 'RNA', 'Proteo', 'CellType', 
              'Kinase', 'TranscriptionFactor', 'ubiq', 'glyco', 'phospho', 'Mutation'],
    Heatmap_trackGroups: [],
    Heatmap_genes: [],
    Heatmap_sampleOrder: {'PTRC':Object.keys(sampleMeta),
                          'PCC':Object.keys(sampleMetaPCC)},
    Heatmap_sampleShow: {},
    Heatmap_tab: 'tab-1',
    Heatmap_landingGenes: ['LXN', 'ARVCF'],
    Heatmap_sortTracks: {'PTRC':['response'], 
                          'PCC':['tissue_level']},
    SampleDashboard_data: cloneDeep(sampleMeta),
    // sampleDashboard_graphs: [],
    sampleDashboard_PTRCgraphs: [
      'response',
      'sex',
      'age_group',
      // 'cohort',
      'AJCC Stage',
      'stage_coding',
      'Biopsy_site_tissue',
      'Progression-free survival event',
      'Progression-free survival days',
      // 'FFPE Sample Type', 
      'Study_Site',
      'ethnicity',
      'ICI_cluster'
    ],
    sampleDashboard_PCCgraphs: [
      // 'response',
      'tissue_level',
      'sex',
      'age_group',
      // 'cohort',
      'tumor_stage',
      'Death',
      'Death or Progression',
      'Radiation-therapy',
      'Chemo-therapy',
      'Immuno-therapy',
      'Targeted-therapy',
      'BRAF_hotspot',
      'NRAS_hotspot',
      // 'KRAS_hotspot',
      'SNF_group_of_interest',
      'transcriptional_state_classification',
      'ubi_cluster',
      'ICI_cluster',
      'glyco cluster',
      // 'FFPE Sample Type', 
      // 'Study_Site',
      // 'ethnicity',
      // 'Protein Subtype'
    ],
    SampleDashboard_percentView: true,
    SampleDashboard_cohortSelected: ['discovery', 'validation'],
    // SampleDashboard_stratifyVar: {'PTRC': {'VarName': 'response',
    //                                         'class1': 'R', 'class2': 'NR',
    //                                       'class1_name': 'Response', 'class2_name': 'Non-response'},
    //                               'PCC': {'VarName': 'tissue_level',
    //                                       'class1': 'Primary', 'class2': 'Metastasis',
    //                                       'class1_name': 'Primary', 'class2_name': 'Metastasis'}
    //                               },
    stratifyVar,
    sampleHisto,
    sampleMeta,
    Scatterplot_data: {},
    Scatterplot_data_raw: {},
    Scatterplot_genes: [],
    Scatterplot_tracks: [],
    Scatterplot_useZScore: false,
    Scatterplot_cohortSelected: ['discovery', 'validation'],
    Scatterplot_tabX: 'tab-1',
    Scatterplot_tabY: 'tab-1',

    view: 'Sample dashboard',
    views: [ 
                'Sample dashboard', 
                'Boxplot', 
                'Heatmap', 
                'Survival curve plot',      
                'Scatterplot',
            ],
    PfsCurveplot_excludedVar: ['Study_Site', 'AJCC Stage', 
                              'Progression-free survival event',
                            'Progression-free survival days',
                          ],

    PfsCurveplot_varType: 'Clinical',
    PfsCurveplot_varTypes: {'PTRC':{'Clinical': [
                                          'response',
                                          'sex',
                                          'cohort',
                                          'age_group',
                                          'stage_coding',
                                          'Biopsy_site_tissue',
                                          // 'FFPE Sample Type',
                                          'ICI_cluster',
                                        ], 
                            'Mutation': categoryTracks.Mutation, 
                            'Genes': available},
                            'PCC':{'Clinical': [
                                          // 'response',
                                          'tissue_level',
                                          'sex',
                                          // 'cohort',
                                          'age_group',
                                          
                                          'tumor_stage',
                                          
                                          'Radiation-therapy',
                                          'Chemo-therapy',
                                          'Immuno-therapy',
                                          'Targeted-therapy',
                                          'BRAF_hotspot',
                                          'NRAS_hotspot',
                                          // 'KRAS_hotspot',
                                          'SNF_group_of_interest',
                                          'transcriptional_state_classification',
                                          'ubi_cluster',
                                          'ICI_cluster',
                                          'glyco cluster',
                                        ], 
                            // 'Mutation': categoryTracksPCC.Mutation, 
                            'Genes': availablePCC},
                                      },
    PfsCurveplot_varName: '',
    PfsCurveplot_varOmics: '',
    PfsCurveplot_contThresh: 50,
    PfsCurveplot_data: {},
    PfsCurveplot_data_raw: {},
    PfsCurveplot_cohortSelected: ['discovery', 'validation'],
    PfsCurveplot_overallCurve: false,

    // pairs: {'test123': 'test123'},
    // login_state: Boolean(Cookies.get('ptrcLoginState')) || false,
    login_state: true,
    login_error: '',
  },
  mutations: {
    SET_VIEW_ATTR(state, { view, attrKey, attrVal}) {
      state[`${view}_${attrKey}`] = attrVal
    },
    SET_BOXPLOT_DATA_TYPE(state, { Boxplot_dataType }) {
      state.Boxplot_dataType = Boxplot_dataType
    },
    SET_BOXPLOT_STRATIFY_BY(state, { Boxplot_stratifyBy }) {
      state.Boxplot_stratifyBy = Boxplot_stratifyBy
    },
    SET_GENES(state, { view, genes }) {
      state[`${view}_genes`] = genes
    },
    SET_HEATMAP_CATEGORY_TRACKS_FILTERED(state, { Heatmap_categoryTracksFiltered, studySelected }) {
      state.Heatmap_categoryTracksFiltered[studySelected] = cloneDeep(Heatmap_categoryTracksFiltered)
    },
    SET_HEATMAP_SHOWN_DATA_TYPES(state, { Heatmap_shownDataTypes }) {
      state.Heatmap_shownDataTypes = Heatmap_shownDataTypes
    },
    SET_HEATMAP_SORT_TRACKS(state, { Heatmap_sortTracks }) {
      state.Heatmap_sortTracks = Heatmap_sortTracks
    },
    SET_HEATMAP_TAB(state, { Heatmap_tab }) {
      state.Heatmap_tab = Heatmap_tab
    },
    SET_HEATMAP_TRACK_GROUPS(state, { Heatmap_trackGroups }) {
      state.Heatmap_trackGroups = Heatmap_trackGroups
    },
    SET_HISTOLOGY_VIEWER_SAMPLE(state, { sample }) {
      state.HistologyViewer_Sample = sample
    },
    SET_SAMPLE_DASHBOARD_GRAPHS(state, { sampleDashboard_graphs }) {
      state.sampleDashboard_graphs = sampleDashboard_graphs
    },
    SET_SAMPLE_DASHBOARD_PERCENT_VIEW(state, { SampleDashboard_percentView }) {
      state.SampleDashboard_percentView = SampleDashboard_percentView
    },
    SET_SAMPLE_ORDER(state, { view, sampleOrder, studySelected }) {
      state[`${view}_sampleOrder`][studySelected] = sampleOrder
    },
    SET_SCATTERPLOT_TRACKS(state, { Scatterplot_tracks }) {
      state.Scatterplot_tracks = Scatterplot_tracks
    },
    SET_USE_Z_SCORE(state, { view, useZScore }) {
      state[`${view}_useZScore`] = useZScore
    },
    SET_VIEW(state, { view }) {
      state.view = view
    },
    SET_VIEW_DATA(state, { view, data }) {
      state[`${view}_data`] = data
    },
    SET_VIEW_DATA_RAW(state, { view, data }) {
      state[`${view}_data_raw`] = data
    },
    SET_COOKIES(state, {cookieName, cookieValue, expiringTime}) {
      // state.loginState = loginState;
      Cookies.set(cookieName, cookieValue, { expires: expiringTime }); // expires in 1 hour
    },
  },
  actions: {
    async getPfsCurveplotData(store, { view, varType, varName, varOmics }) {


    },
    async getTrackData(store, { view, tracks, combine_bool, studySelected, stratifyVar}) {
      const trackPromises = [...tracks].map((track) => {
        return getTrackData(track, studySelected)
      })

      const trackRes = await Promise.all(trackPromises)

      const k_track_v_data = Object.fromEntries(trackRes)
      console.log('getTrackData trackPromises', view, trackRes)
      console.log('getTrackData stratifyVar', view, stratifyVar)
      const combinedDataNotNormalized = transform_k_track_v_data_noTN_zbool2({k_track_v_data: k_track_v_data, 
                                                                              z_bool: false,
                                                                              combine_bool: combine_bool,
                                                                            studySelected: studySelected,
                                                                            stratifyVarName: stratifyVar})
      const normalizedCombinedData = transform_k_track_v_data_noTN_zbool2({k_track_v_data: k_track_v_data, 
                                                                              z_bool: true,
                                                                              combine_bool: combine_bool,
                                                                            studySelected: studySelected,
                                                                            stratifyVarName: stratifyVar})
      // console.log(combinedDataNotNormalized['ANGPTL4 rna N'])
      store.commit('SET_VIEW_DATA', { view, data: normalizedCombinedData })
      store.commit('SET_VIEW_DATA_RAW', { view, data: combinedDataNotNormalized })
      console.log(view)
      console.log(store.state.Boxplot_data)
      
      if ( view === 'Heatmap ') { 
        store.dispatch('sortSamples', { view, studySelected })
      }
    },
    async getTracks(store, { view, genes, combine_bool = false, 
                  studySelected = 'PTRC', stratifyVar = 'default'}) {
      const trackPromises = [...genes].map((gene) => {
        return getTracks(gene, studySelected)
      })
      
      const trackRes = await Promise.all(trackPromises)
      
      let k_gene_v_tracks = Object.fromEntries(trackRes)
      console.log('getTracks', genes)
      console.log('getTracks', k_gene_v_tracks)
      const tracks = Object.values(k_gene_v_tracks).flat()
      console.log('getTracks', tracks)
      store.dispatch('getTrackData', { view, tracks, combine_bool, studySelected, stratifyVar })
      store.commit('SET_GENES', { view, genes })
    },
    async login(store, { username, password }) {
      if (Cookies.get('ptrcLoginState') === true) {
        return true
      } else {
        var loginState = false
        const loginStatePromise = checkAuthentication(username, password)
        loginState = await loginStatePromise
        console.log('loginState', loginState)
        var login_error = ''
        if (!loginState) {
          login_error = 'Invalid username or password'
        }
        store.commit('SET_VIEW_ATTR', {view: 'login', attrKey: 'error', attrVal: login_error})
        store.commit('SET_VIEW_ATTR', {view: 'login', attrKey: 'state', attrVal: loginState})
        // return loginState;
        store.commit('SET_COOKIES', {cookieName: 'ptrcLoginState', 
          cookieValue: loginState, expiringTime: 1/(24)})
      }
    },
    async updateText(store, { view, attrKey, attrVal }) {

    },
    setCookie(store, {name, value, expires}) {
      document.cookie = `${name}=${value}; expires=${expires.toUTCString()}; path=/`;
    },
    setViewAttr(store, { view, attrKey, attrVal }) {
      store.commit('SET_VIEW_ATTR', { view, attrKey, attrVal })
    },
    setBoxplotDataType(store, { Boxplot_dataType }) {
      store.commit('SET_BOXPLOT_DATA_TYPE', { Boxplot_dataType })
    },
    setBoxplotStratifyBy(store, { Boxplot_stratifyBy }) {
      store.commit('SET_BOXPLOT_STRATIFY_BY', { Boxplot_stratifyBy })
    },
    setHeatmapCategoryTracksFiltered(store, { Heatmap_categoryTracksFiltered, studySelected }) {
      store.commit('SET_HEATMAP_CATEGORY_TRACKS_FILTERED', { Heatmap_categoryTracksFiltered, studySelected })
    },
    setHeatmapShownDataTypes(store, { Heatmap_shownDataTypes }) {
      store.commit('SET_HEATMAP_SHOWN_DATA_TYPES', { Heatmap_shownDataTypes })
    },
    setHeatmapSortTracks(store, { Heatmap_sortTracks, studySelected }) {
      store.commit('SET_HEATMAP_SORT_TRACKS', { Heatmap_sortTracks, studySelected })
      store.dispatch('sortSamples', { view: 'Heatmap', studySelected: studySelected })
    },
    setHeatmapTab(store, { Heatmap_tab }) {
      store.commit('SET_HEATMAP_TAB', { Heatmap_tab })
    },
    setHeatmapTrackGroups(store, { Heatmap_trackGroups }) {
      store.commit('SET_HEATMAP_TRACK_GROUPS', { Heatmap_trackGroups })
    },
    setHistologyViewerSample(store, { sample }) {
      store.commit('SET_HISTOLOGY_VIEWER_SAMPLE', { sample })
    },
    setSampleDashboardGraphs(store, { sampleDashboard_graphs }) {
      store.commit('SET_SAMPLE_DASHBOARD_GRAPHS', { sampleDashboard_graphs })
    },
    setSampleDashboardPercentView(store, { SampleDashboard_percentView }) {
      store.commit('SET_SAMPLE_DASHBOARD_PERCENT_VIEW', { SampleDashboard_percentView })
    },
    setScatterplotTracks(store, { Scatterplot_tracks }) {
      store.commit('SET_SCATTERPLOT_TRACKS', { Scatterplot_tracks })
    },
    setView(store, { view }) {
      store.commit('SET_VIEW', { view })
    },
    sortSamples(store, { view, studySelected }) {
      const sortTracks = store.state[`${view}_sortTracks`].map(el => [el])
      // https://jsfiddle.net/L9x8ao0r/20

      const Heatmap_data =  store.state.Heatmap_data
      console.log('sortSamples Heatmap_data', Heatmap_data)
      let combinedData = {}
      let sampleMetaVals = {}
      console.log('sortSamples studySelected', studySelected)
      console.log('sortSamples store.state.trackDetailsList', store.state.trackDetailsList[studySelected])
      Object.entries(store.state.trackDetailsList[studySelected]).forEach(([category, trackDetail]) => {
        sampleMetaVals[category] = {}
        trackDetail.forEach((track) => {
          sampleMetaVals[category][track.label] = track.value
        })
      })

      Object.keys(store.state.sampleMetaList[studySelected]).forEach((sample) => {
        let sampleMetaSample = {}
        Object.entries(store.state.sampleMetaList[studySelected][sample]).forEach(([track, val]) => {
          sampleMetaSample[track] = track in sampleMetaVals ? sampleMetaVals[track][val] : val
        })
        let res = {
          id: sample,
        }
        Object.keys(Heatmap_data).forEach(track => {
          res[track] = Heatmap_data[track].data[sample]
        })
        combinedData[sample] = {
          ...res,
          ...sampleMetaSample
        }
      })
      var sortedTrackFunc = sortFn(sortTracks)
      const sorted = Object.values(combinedData).sort(sortedTrackFunc)
      const sampleOrder = sorted.map(el => el.id)
      // const sorted = Object.values(combinedData).sort(sortFn(sortTracks))
      // const sampleOrder = sorted.map(el => el.id)
      
      store.commit('SET_SAMPLE_ORDER', { view, sampleOrder, studySelected })
    },
    setUseZScore(store, { view, useZScore }) {
      store.commit('SET_USE_Z_SCORE', { view, useZScore })
    },
  },
})
